// import { doc, setDoc } from "firebase/firestore";
// import { db } from "@/firebase";
import { mapState } from "vuex";

export const agent = {
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      chat: (state) => state.agent.chat,
    }),
    loading: {
      get() {
        return this.$store.state.agent.loading;
      },
      set(value) {
        this.$store.commit("setAgentLoading", value);
      },
    },
  },
};
